import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';
import './StrategicPlanning.css';

const StrategicPlanning = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    { labelKey: 'nav.services', href: '/#services' },
    { labelKey: 'services.strategicPlanning' }
  ];

  useEffect(() => {
    document.title = `${t('pages.strategicPlanning.title')} - ${t('common.companyName')}`;
  }, [t]);

  return (
    <PageTemplate 
      titleKey="pages.strategicPlanning.title"
      subtitleKey="pages.strategicPlanning.subtitle"
      breadcrumbs={breadcrumbs}
    >
      {/* 顶部CTA按钮 */}
      <div className="strategic-planning-cta-top">
        <a href="/connect-us" className="cta-button-primary">
          {t('pages.strategicPlanning.cta')}
        </a>
      </div>

      {/* 新篇章的挑战与机遇区域 */}
      <div className="new-frontier-section">
        <h2>{t('pages.strategicPlanning.newFrontier.title')}</h2>
        <div className="frontier-grid">
          {/* 您的顾虑列 */}
          <div className="concerns-column">
            <h3>{t('pages.strategicPlanning.newFrontier.concerns.title')}</h3>
            {[1, 2, 3, 4].map((num) => (
              <div key={num} className="concern-item">
                <h4>{t(`pages.strategicPlanning.newFrontier.concerns.item${num}.title`)}</h4>
                <p>{t(`pages.strategicPlanning.newFrontier.concerns.item${num}.desc`)}</p>
              </div>
            ))}
          </div>
          
          {/* 我们的价值列 */}
          <div className="solutions-column">
            <h3>{t('pages.strategicPlanning.newFrontier.solutions.title')}</h3>
            {[1, 2, 3, 4].map((num) => (
              <div key={num} className="solution-item">
                <h4>{t(`pages.strategicPlanning.newFrontier.solutions.item${num}.title`)}</h4>
                <p>{t(`pages.strategicPlanning.newFrontier.solutions.item${num}.desc`)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 我们的愿景区域 */}
      <div className="vision-section">
        <h2>{t('pages.strategicPlanning.vision.title')}</h2>
        <p className="vision-description">
          {t('pages.strategicPlanning.vision.description')}
        </p>
      </div>

      {/* 核心服务区域 */}
      <div className="services-section">
        <h2>{t('pages.strategicPlanning.services.title')}</h2>
        <div className="services-list">
          {[1, 2, 3, 4, 5, 6].map((num) => (
            <div key={num} className="service-item">
              <h3>{t(`pages.strategicPlanning.services.item${num}.title`)}</h3>
              <p>{t(`pages.strategicPlanning.services.item${num}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>

      {/* 方法论流程区域 */}
      <div className="methodology-section">
        <h2>{t('pages.strategicPlanning.methodology.title')}</h2>
        <p className="methodology-summary">
          {t('pages.strategicPlanning.methodology.summary')}
        </p>
        <div className="methodology-timeline">
          {[1, 2, 3, 4].map((num, index) => (
            <React.Fragment key={num}>
              <div className="methodology-step">
                <div className="step-number">{num}</div>
                <div className="step-content">
                  <h3>{t(`pages.strategicPlanning.methodology.step${num}.title`)}</h3>
                  <p>{t(`pages.strategicPlanning.methodology.step${num}.desc`)}</p>
                </div>
              </div>
              {index < 3 && <div className="step-arrow">→</div>}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* 为何选择我们区域 */}
      <div className="why-us-section">
        <h2>{t('pages.strategicPlanning.whyUs.title')}</h2>
        <div className="advantages-grid">
          {[1, 2, 3, 4].map((num) => (
            <div key={num} className="advantage-card">
              <h3>{t(`pages.strategicPlanning.whyUs.advantages.item${num}.title`)}</h3>
              <p>{t(`pages.strategicPlanning.whyUs.advantages.item${num}.desc`)}</p>
            </div>
          ))}
        </div>
      </div>

      {/* 统计数据区域 */}
      <div className="stats-section">
        <div className="stats-grid-modern">
          <div className="stat-card">
            <div className="stat-number">
              {t('pages.strategicPlanning.stats.projects.number')}
            </div>
            <div className="stat-label">
              {t('pages.strategicPlanning.stats.projects.label')}
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-number">
              {t('pages.strategicPlanning.stats.success.number')}
            </div>
            <div className="stat-label">
              {t('pages.strategicPlanning.stats.success.label')}
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-number">
              {t('pages.strategicPlanning.stats.markets.number')}
            </div>
            <div className="stat-label">
              {t('pages.strategicPlanning.stats.markets.label')}
            </div>
          </div>
        </div>
      </div>

      {/* 最终行动号召区域 */}
      <div className="final-cta-section">
        <h2>{t('pages.strategicPlanning.callToAction.title')}</h2>
        <p>{t('pages.strategicPlanning.callToAction.description')}</p>
        <a href="/connect-us" className="cta-button-large">
          {t('pages.strategicPlanning.callToAction.button')}
        </a>
      </div>
    </PageTemplate>
  );
};

export default StrategicPlanning;
